export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["hour"] = "h";
    TimeUnit["minute"] = "m";
    TimeUnit["second"] = "s";
    TimeUnit["a"] = "a";
})(TimeUnit || (TimeUnit = {}));
export var ColumnAlign;
(function (ColumnAlign) {
    ColumnAlign["left"] = "left";
    ColumnAlign["center"] = "center";
    ColumnAlign["right"] = "right";
})(ColumnAlign || (ColumnAlign = {}));
export var LovFieldType;
(function (LovFieldType) {
    LovFieldType["INT"] = "INT";
    LovFieldType["TEXT"] = "TEXT";
    LovFieldType["DATE"] = "DATE";
    LovFieldType["DATETIME"] = "DATETIME";
    LovFieldType["POPUP"] = "POPUP";
    LovFieldType["SELECT"] = "SELECT";
})(LovFieldType || (LovFieldType = {}));
